/**
 * Which use opened deposit capture, which decides whether it is sealed.
 *
 * Kept in its own file because the dialog opener, its component and the capture
 * panel all need it; importing it from any of those would close a cycle between
 * them and leave one resolving as undefined at load.
 */
export enum TakeDepositEntry {
  Revisit = 'revisit',
  Booking = 'booking',
}
